"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useRef } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
interface AnimatedDropZoneProps {
  onFileSelect: (file: File) => void;
  isUploading: boolean;
}
export default function AnimatedDropZone(t0) {
  const $ = _c(26);
  const {
    onFileSelect,
    isUploading
  } = t0;
  const {
    theme
  } = useTheme();
  const isDark = theme === "dark";
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.preventDefault();
      setIsDragging(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleDragOver = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_0 => {
      e_0.preventDefault();
      setIsDragging(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleDragLeave = t2;
  let t3;
  if ($[2] !== onFileSelect) {
    t3 = e_1 => {
      e_1.preventDefault();
      setIsDragging(false);
      const files = e_1.dataTransfer.files;
      if (files.length > 0 && files[0].type === "application/pdf") {
        onFileSelect(files[0]);
      }
    };
    $[2] = onFileSelect;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleDrop = t3;
  let t4;
  if ($[4] !== onFileSelect) {
    t4 = e_2 => {
      if (e_2.target.files && e_2.target.files.length > 0) {
        onFileSelect(e_2.target.files[0]);
      }
    };
    $[4] = onFileSelect;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleFileChange = t4;
  const t5 = `
                relative w-full h-64 rounded-3xl border-2 border-dashed transition-all duration-300 cursor-pointer overflow-hidden group
                ${isDragging ? "border-purple-500 scale-[1.02] shadow-[0_0_50px_rgba(168,85,247,0.2)]" : ""}
                ${isDragging ? isDark ? "bg-purple-500/10" : "bg-purple-100" : isDark ? "border-white/10 bg-white/5 hover:bg-white/10 hover:border-purple-500/50" : "border-slate-200 bg-white hover:bg-purple-50 hover:border-purple-300"}
            `;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => fileInputRef.current?.click();
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== handleFileChange) {
    t7 = <input type="file" ref={fileInputRef} onChange={handleFileChange} accept=".pdf" className="hidden" />;
    $[7] = handleFileChange;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `absolute inset-0 pointer-events-none transition-opacity duration-500 ${isDragging ? "opacity-[0.1]" : isDark ? "opacity-[0.03]" : "opacity-[0.02]"}`;
  const t9 = `radial-gradient(circle at 1px 1px, ${isDark ? "white" : "#6b21a8"} 1px, transparent 0)`;
  let t10;
  if ($[9] !== t9) {
    t10 = {
      backgroundImage: t9,
      backgroundSize: "24px 24px"
    };
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t8) {
    t11 = <div className={t8} style={t10} />;
    $[11] = t10;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== isDark || $[15] !== isDragging || $[16] !== isUploading) {
    t12 = <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center z-10">{isUploading ? <div className="flex flex-col items-center animate-pulse"><div className="w-16 h-16 mb-4 relative"><div className="absolute inset-0 rounded-full border-4 border-purple-500/30" /><div className="absolute inset-0 rounded-full border-4 border-t-purple-500 animate-spin" /><div className="absolute inset-0 flex items-center justify-center text-2xl">⚡</div></div><h3 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-blue-500">Analyzing Resume...</h3><p className={`text-sm mt-2 ${isDark ? "text-slate-400" : "text-slate-500"}`}>Our AI is reading your document</p></div> : <><div className={`
                            w-20 h-20 mb-6 rounded-2xl bg-gradient-to-br from-purple-500/20 to-blue-500/20 
                            flex items-center justify-center text-4xl transition-transform duration-300
                            ${isDragging ? "scale-110 rotate-3" : "group-hover:scale-105 group-hover:-rotate-3"}
                        `}>{isDragging ? "\uD83D\uDCC2" : "\uD83D\uDCC4"}</div><h3 className={`text-2xl font-bold mb-2 transition-colors ${isDark ? "text-white group-hover:text-purple-300" : "text-slate-800 group-hover:text-purple-600"}`}>{isDragging ? "Drop it like it's hot!" : "Upload Resume PDF"}</h3><p className={isDark ? "text-slate-400" : "text-slate-500"}>{"Drag & drop your resume here, or "}<span className={`border-b pb-0.5 ${isDark ? "text-purple-400 border-purple-400/30" : "text-purple-600 border-purple-600/30"}`}>browse files</span></p></>}</div>;
    $[14] = isDark;
    $[15] = isDragging;
    $[16] = isUploading;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="absolute top-0 left-0 w-20 h-20 bg-purple-500/20 blur-[40px] rounded-full pointer-events-none transition-opacity group-hover:opacity-100 opacity-0" />;
    t14 = <div className="absolute bottom-0 right-0 w-20 h-20 bg-blue-500/20 blur-[40px] rounded-full pointer-events-none transition-opacity group-hover:opacity-100 opacity-0" />;
    $[18] = t13;
    $[19] = t14;
  } else {
    t13 = $[18];
    t14 = $[19];
  }
  let t15;
  if ($[20] !== handleDrop || $[21] !== t11 || $[22] !== t12 || $[23] !== t5 || $[24] !== t7) {
    t15 = <div className={t5} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} onClick={t6}>{t7}{t11}{t12}{t13}{t14}</div>;
    $[20] = handleDrop;
    $[21] = t11;
    $[22] = t12;
    $[23] = t5;
    $[24] = t7;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
}